import axios from "../axios-auth";

export const maintenanceTypeService = {
    getMaintenanceTypeList,
    saveMaintenanceType,
    getMaintenanceTypeDetail,
    getMaintenanceTypesByStatus,
}

function getMaintenanceTypeList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    }

    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/maintenance-types", { params });
}

function saveMaintenanceType(maintenanceType) {
    if (!maintenanceType.id) {
        // new 
        return axios.post("/auth/maintenance-type", maintenanceType);
    } else {
        // edit
        return axios.put("/auth/maintenance-type", maintenanceType);
    }
}

function getMaintenanceTypeDetail(id) {
    return axios.get("/auth/maintenance-type/" + id);
}

function getMaintenanceTypesByStatus(status) {
    return axios.get("/auth/maintenance-types-by-status/" + status);
}